export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Wip 1_12.6e3932d2.jpg";